import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Integration icon. Exported from Figma (Bombiix 2026). */
const IntegrationIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <defs>
      <clipPath id="integration-icon-clip">
        <rect width="16" height="16" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
    <g clipPath="url(#integration-icon-clip)">
      <path
        d="M16.6663 10.0007C16.6663 13.6825 13.6816 16.6673 9.99967 16.6673M16.6663 10.0007C16.6663 6.31875 13.6816 3.33398 9.99967 3.33398M16.6663 10.0007H3.33301M9.99967 16.6673C6.31778 16.6673 3.33301 13.6825 3.33301 10.0007M9.99967 16.6673C11.6672 14.8417 12.6148 12.4726 12.6663 10.0007C12.6148 7.52867 11.6672 5.15955 9.99967 3.33398M9.99967 16.6673C8.33215 14.8417 7.38451 12.4726 7.33301 10.0007C7.38451 7.52867 8.33215 5.15955 9.99967 3.33398M3.33301 10.0007C3.33301 6.31875 6.31778 3.33398 9.99967 3.33398"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default IntegrationIcon;
